import { render, staticRenderFns } from "./BlindBox.vue?vue&type=template&id=b7a7ef78&scoped=true&"
import script from "./BlindBox.vue?vue&type=script&lang=js&"
export * from "./BlindBox.vue?vue&type=script&lang=js&"
import style0 from "./BlindBox.vue?vue&type=style&index=0&id=b7a7ef78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a7ef78",
  null
  
)

export default component.exports